import { truncate } from 'lodash';

const filter = (value, length = 30): string => {
  if (!value) {
    return ''
  }

  const options = {
    length
  }

  return truncate(value, options)
}

export default filter
